import { h, render } from "preact";
import { useItemsStorage, StorageProvider } from "./useItemsStorage";
import { useFetchItems } from "./useFetchItems";

export function BookmarksLength() {
  const { bookmarks } = useItemsStorage();
  return bookmarks.length > 0 ? <span>({bookmarks.length})</span> : null;
}

export function BookmarkButton({ rentalId, variant }) {
  const { bookmarks, toggleBookmark } = useItemsStorage();
  const present = bookmarks.includes(rentalId);
  return (
    <button
      className={`bookmarkbutton${present ? " bookmarkbutton--active" : ""}${variant === "button" ? " bookmarkbutton--withtext" : ""}${variant === "overlay" ? " bookmarkbutton--overlay" : ""}`}
      type="button"
      aria-pressed={present}
      onClick={() => toggleBookmark(rentalId)}
    >
      <svg fill="none" viewBox="0 0 24 24" strokeWidth="1.5" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
        ></path>
      </svg>
      <span className={variant !== "button" ? "sr-only" : ""}>
        {present
          ? global.Translator.trans("bookmarks.buttons.remove", {}, "js")
          : global.Translator.trans("bookmarks.buttons.add", {}, "js")}
      </span>
    </button>
  );
}

export function BookmarksPage() {
  const { bookmarks, clearBookmarks } = useItemsStorage();
  const page = useFetchItems({ type: "bookmarks", ids: bookmarks });

  if (!page.length) {
    return null;
  }

  // Once rendered, bind button
  window.setTimeout(() => {
    window.bindBookmarkActions();
  }, 300);

  return (
    <div>
      <div className="text-right">
        <button onClick={clearBookmarks} className="btn btn--danger">
          &#x2716;{" "}
          {global.Translator.trans("bookmarks.buttons.remove_all", {}, "js")}
        </button>
      </div>
      <div dangerouslySetInnerHTML={{ __html: page }} />
    </div>
  );
}

window.bindBookmarkActions = function () {
  const bookmarkButtonsList = document.querySelectorAll(
    ".bookmarkbutton-wrapper"
  );
  if (!bookmarkButtonsList) {
    return;
  }
  bookmarkButtonsList.forEach((item) => {
    if (item.innerHTML.trim() !== "") {
      return;
    }
    render(
      h(
        StorageProvider,
        null,
        h(BookmarkButton, {
          rentalId: item.getAttribute("data-rental-id"),
          variant: item.getAttribute("data-variant") ?? "marker",
        })
      ),
      item
    );
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    window.bindBookmarkActions();
  });
} else {
  window.bindBookmarkActions();
}

// Rendering
if (document.getElementById("bookmarks")) {
  render(
    h(StorageProvider, null, h(BookmarksPage, null)),
    document.getElementById("bookmarks")
  );
}

if (document.getElementById("bookmarksLength")) {
  render(
    h(StorageProvider, null, h(BookmarksLength, null)),
    document.getElementById("bookmarksLength")
  );
}
